import { PaginatedList } from "@tellescope/ui";
import { useTellescopeInfiniteQuery } from "@tellescope/tanstack-query";
import { InboxThreadListSentItem } from "./list-items";
import { formatDate, formatEmailTitle } from "@tellescope/utils";
import { groupThreadsByDate } from "../../utils";

export const InboxSentList = () => {
  const sentThreadsQuery = useTellescopeInfiniteQuery({
    model: "inbox_threads",
    method: "load_threads",
    request: {
      autobuild: true,
      sortBy: "outboundTimestamp",
    },
    getNextPageParam: (lastPage) =>
      (lastPage.threads.at(-1)?.outboundTimestamp ?? lastPage.threads.at(-1)?.timestamp) || undefined,
    initialPageParam: undefined,
    paginateRequest: (lastTimestamp, request) => ({
      ...request,
      lastTimestamp,
    }),
    select: (data) => {
      const threads = data.pages.flatMap((page) => page.threads);
      const groupedThreads = groupThreadsByDate(threads, { timestampField: "outboundTimestamp" });
      return { threads, groupedThreads };
    },
  });

  return (
    <PaginatedList className="p-4 space-y-2 flex-1" onBottomReached={sentThreadsQuery.fetchNextPage}>
      {sentThreadsQuery.data?.groupedThreads.map((group, i) => (
        <div key={group.groupKey} className={i ? "mt-3" : undefined}>
          <h3 className="mb-3 text-muted-foreground font-bold text-sm">
            {formatDate(
              group.threads[0]?.outboundTimestamp || group.threads[0]?.timestamp || new Date(),
              "MMMM D, YYYY",
              {
                unit: "years",
                amount: Infinity,
                direction: "both",
                approximate: true,
              }
            )}
          </h3>
          <div>
            {group.threads.map((thread, i) => (
              <InboxThreadListSentItem
                key={thread.id}
                thread={thread}
                enduserIds={thread.enduserIds}
                title={thread.type === "Email" ? formatEmailTitle(thread.title) : thread.title}
                preview={thread.outboundPreview ?? thread.preview}
                timestamp={thread.outboundTimestamp ?? thread.timestamp}
                channel={thread.type}
                groupPosition={
                  group.threads.length === 1
                    ? undefined
                    : i === 0
                    ? "top"
                    : i === group.threads.length - 1
                    ? "bottom"
                    : "middle"
                }
              />
            ))}
          </div>
        </div>
      ))}
    </PaginatedList>
  );
};
